(function(){
    'use strict';

    angular
        .module('completeAir')
        .factory('channelExternalService',channelExternalService);

    channelExternalService.$inject = ['$http', 'CONFIG','messageService'];

    function channelExternalService($http, CONFIG, messageService){

        var urlBase = CONFIG.API_URL + '/' + CONFIG.API_REPORT + '/' + CONFIG.API + '/report-of-transactions';
        var urlBaseChannel = CONFIG.API_URL + '/' + CONFIG.API_REPORT + '/' + CONFIG.API + '/buy-external/report';

        var service = {
            getTransactionsPassages: getTransactionsPassages,
            getTransactionsPassagesChannel: getTransactionsPassagesChannel,
            getTransactionsCargos: getTransactionsCargos,
            getTransactionsLuggage: getTransactionsLuggage,
            transactionModel: transactionModel,
            transactionFilter: transactionFilter,
            getForChargingGuidesPayable: getForChargingGuidesPayable,
            getIncomeRoute: getIncomeRoute
        };

        return service;

        function getTransactionsPassages(data){
            var params = '?fromDate='+data.fromDate + '&toDate=' + data.toDate + '&currency=' + data.currency +
                '&regionId=' + data.region + '&branchOfficeId=' + data.branchOffice + '&branch=' + data.branch +
                '&employee=' + data.employee + '&airRate=' + data.airRate + '&detail=' + data.detail;
            return $http.get(urlBase + params)
                .then(function(response){
                    return response;
                }, function(){
                    messageService.findError('');
                });
        }

        function getTransactionsPassagesChannel(data){
            var params = '?from='+data.fromDate + '&to=' + data.toDate + '&detail=' + data.detail /*+ '&password=' + data.password*/;
            return $http.get(urlBaseChannel + params)
                .then(function(response){
                    return response;
                }, function(){
                    messageService.findError('');
                });
        }

        function getTransactionsCargos(data){
            var params = '/cargo-transactions?fromDate='+data.fromDate + '&toDate=' + data.toDate +
                '&region=' + data.region + '&office=' + data.branchOffice +
                '&employee=' + data.employee + '&detailed=' + data.detail;
            return $http.get(urlBase + params)
                .then(function(response){
                    return response;
                }, function(){
                    messageService.findError('');
                });
        }

        function getTransactionsLuggage(data){
            return $http.get(urlBase + '/luggage-transactions' + '?fromDate='+data.fromDate + '&toDate=' + data.toDate +
                '&region=' + data.region + '&office=' + data.branchOffice +
                '&employee=' + data.employee + '&detailed=' + data.detail)
                .then(function(response){
                    return response;
                }, function(){
                    messageService.findError('');
                });
        }

        function getForChargingGuidesPayable(data){
            var params = '/cargo-destiny-paid-transactions?fromDate='+data.fromDate + '&toDate=' + data.toDate +
                '&cityId=' + data.city + '&detailed=' + data.detail;
            return $http.get(urlBase + params)
                .then(function(response){
                    return response;
                }, function(){
                    messageService.findError('');
                });
        }

        function getIncomeRoute(data){
            var params = '/cargo-route-transactions?fromDate='+data.fromDate + '&toDate=' + data.toDate +
                '&originCityId=' + data.originCity + '&destinyCityId=' + data.destinyCity;
            return $http.get(urlBase + params)
                .then(function(response){
                    return response;
                }, function(){
                    messageService.findError('');
                });
        }

        function transactionModel() {
            return {
                fromDate: null,
                toDate: null,
                currency: null,
                region: null,
                branchOffice: null,
                employee: null,
                airRate: null,
                branch: true,
                detail: null
            }
        }

        function transactionFilter() {
            return {
                currency: null,
                region: null,
                branchOffice: null,
                user: null,
                rate: true,
                detail: true,
                fromDate: null,
                toDate: ''
            };
        }
    }
})();
